module.exports = __webpack_public_path__ + "img/四川天府新区麓湖小学.b8faa84c.jpg";